import React, { useState } from 'react'
import Page from 'src/components/Page'
import {
    Grid,
    Button,
    Typography,
    TextField,
    Snackbar
} from '@material-ui/core';
import { Autocomplete } from '@mui/material';
import { Fade } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles'
import Alert from 'src/components/Alert';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ArcelikLogo from 'src/assets/images/arcelik_marka_logo.png';
import AsrBolgeHizmetAdetleri from 'src/assets/AsrExcel/ASR_BOLGE_HIZMET_ADETLERI.xlsx'
import AsrBolgeServisAdetleri from 'src/assets/AsrExcel/ASR_BOLGE_SERVIS_ADETLERI.xlsx'
import AsrMontajSatisBolgeleri from 'src/assets/AsrExcel/ASR_MONTAJ_SATIS_BOLGELERI.xlsx'
import AsrMontajUrunBazli from 'src/assets/AsrExcel/ASR_MONTAJ_URUN_BAZLI.xlsx'
import AsrUdsDegisimNedenleri from 'src/assets/AsrExcel/ASR_UDS_DEGISIM_NEDENLERI.xlsx'
import AsrUdsDegisimTuru from 'src/assets/AsrExcel/ASR_UDS_DEGISIM_TURU.xlsx'
import AsrUrunHizmetAdet from 'src/assets/AsrExcel/ASR_URUN_HIZMET_ADET.xlsx'
import HandymanIcon from '@mui/icons-material/Handyman';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import InventoryIcon from '@mui/icons-material/Inventory';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },
    header: {
        fontFamily: 'AssistantRegular',
        paddingTop: '1rem',
        paddingBottom: '1rem'
    },
    container: {
        overflow: 'auto',
        maxHeight: '90vh'
    },
    downloadButton: {
        width: '20rem',
        marginTop: '1rem'
    }
}));

const files = [
    {
        path: AsrBolgeHizmetAdetleri,
        fileName: 'ASR_BOLGE_HIZMET_ADETLERI.xlsx',
        displayName: 'Bölge Hizmet Adetleri',
        groupType: 'Bölge'
    },
    {
        path: AsrBolgeServisAdetleri,
        fileName: 'ASR_BOLGE_SERVIS_ADETLERI.xlsx',
        displayName: 'Bölge Servis Adetleri',
        groupType: 'Bölge'
    },
    {
        path: AsrMontajSatisBolgeleri,
        fileName: 'ASR_MONTAJ_SATIS_BOLGELERI.xlsx',
        displayName: 'Montaj Satış Bölgeleri',
        groupType: 'Montaj'
    },
    {
        path: AsrMontajUrunBazli,
        fileName: 'ASR_MONTAJ_URUN_BAZLI.xlsx',
        displayName: 'Montaj Ürün Bazlı',
        groupType: 'Montaj'
    },
    {
        path: AsrUdsDegisimNedenleri,
        fileName: 'ASR_UDS_DEGISIM_NEDENLERI.xlsx',
        displayName: 'ÜDS Değişim Nedenleri',
        groupType: 'ÜDS'
    },
    {
        path: AsrUdsDegisimTuru,
        fileName: 'ASR_UDS_DEGISIM_TURU.xlsx',
        displayName: 'ÜDS Değişim Türü',
        groupType: 'ÜDS'
    },
    {
        path: AsrUrunHizmetAdet,
        fileName: 'ASR_URUN_HIZMET_ADET.xlsx',
        displayName: 'Ürün Hizmet Adet',
        groupType: 'Ürün'
    }
];

const getGroupIcon = (groupType) => {
    if (groupType === 'Bölge') {
        return <HomeRepairServiceIcon style={{ marginRight: '0.5rem', fontSize: '1.5rem' }} />;
    } else if (groupType === 'Montaj') {
        return <HandymanIcon style={{ marginRight: '0.5rem', fontSize: '1.5rem' }} />;
    } else if (groupType === 'ÜDS') {
        return <CurrencyExchangeIcon style={{ marginRight: '0.5rem', fontSize: '1.5rem' }} />;
    } else {
        return <InventoryIcon style={{ marginRight: '0.5rem', fontSize: '1.5rem' }} />;
    }
};

function AsrReports() {
    const classes = useStyles();

    const [selectedFile, setSelectedFile] = useState("");
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [responseMessage, setResponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });

    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const handleDownload = async () => {
        if (selectedFile) {
            const filePath = selectedFile.path;
            try {
                const response = await axios.head(filePath);

                if (response.status === 200) {
                    // Dosya mevcut ve indirilebilir
                    const link = document.createElement('a');
                    link.href = filePath;
                    link.setAttribute('download', selectedFile.displayName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    setResponseMessage('İndirme işlemi tamamlandı!');
                    setUyariTip('success');
                    setUyari(true);
                } else {
                    // Dosya mevcut değil veya indirilemez
                    setResponseMessage('Dosya indirilemedi. Lütfen tekrar deneyin.');
                    setUyariTip('error');
                    setUyari(true);
                }
            } catch (error) {
                // Ağ hatası veya başka bir hata
                setResponseMessage('İndirme sırasında bir hata oluştu.');
                setUyariTip('error');
                setUyari(true);
            }
        }
    };

    return (
        <>
            <Snackbar
                open={uyari}
                autoHideDuration={2000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                />
            </Snackbar>
            <Page className={classes.root}>
                <Grid container spacing={1} justifyContent="center" alignItems="center" className={classes.container}>
                    <Grid item xs={12} sm={12} md={12} container direction="column" alignItems="center">
                        <Grid item xs={12}>
                            <Fade timeout={1000} in={true}>
                                <img
                                    src={ArcelikLogo}
                                    alt="Arçelik"
                                    style={{ width: '100%', maxWidth: 200 }}
                                />
                            </Fade>
                        </Grid>
                        <Grid item xs={12}>
                            <Fade in={true} timeout={1000}>
                                <Typography
                                    className={classes.header}
                                    variant="h2"
                                    gutterBottom
                                >
                                    Arçelik Servis Raporları
                                </Typography>
                            </Fade>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} container direction="column" alignItems="center">
                        <Grid item xs={12}>
                            <Fade in={true} timeout={1000}>
                                <Autocomplete
                                    value={selectedFile || null}
                                    style={{ width: '20rem' }}
                                    onChange={(event, newValue) => {
                                        setSelectedFile(newValue);
                                    }}
                                    options={files}
                                    groupBy={(option) => option.groupType}
                                    getOptionLabel={(option) => option.displayName}
                                    renderInput={(params) => <TextField {...params} label="Excel Dosya Türü" variant="outlined" />}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            {option.displayName}
                                        </li>
                                    )}
                                    renderGroup={(params) => (
                                        <li key={params.key}>
                                            <div style={{
                                                fontSize: '1.2rem',
                                                fontWeight: 'bold',
                                                borderBottom: '1px solid #ccc',
                                                marginTop: '1rem',
                                                paddingLeft: '0.3rem',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                {getGroupIcon(params.group)} {params.group}
                                            </div>
                                            <ul style={{ padding: 0 }}>
                                                {params.children}
                                            </ul>
                                        </li>
                                    )}
                                    sx={{ '& .MuiAutocomplete-endAdornment': { top: 'unset' } }}
                                />
                            </Fade>
                        </Grid>
                        <Grid item xs={12}>
                            <Fade in={true} timeout={1000}>
                                <Typography
                                    variant="subtitle2"
                                    style={{ fontFamily: "Segoe UI" }}
                                >
                                    Lütfen indirmek istediğiniz Exceli seçiniz...
                                </Typography>
                            </Fade>
                        </Grid>
                        <Grid item xs={12}>
                            <Fade in={true} timeout={1000}>
                                <Button
                                    className={classes.downloadButton}
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => { handleDownload(); }}
                                    endIcon={<FileDownloadIcon />}
                                    disabled={!selectedFile}
                                >
                                    İNDİR
                                </Button>
                            </Fade>
                        </Grid>
                    </Grid>
                </Grid>
            </Page>
        </>
    );
}

export default AsrReports;